/* ============================================================
   LUXE LINEN — x-collection.js
   Collection page: filters drawer, grid/list view toggle with
   memory, load-more button, infinite scroll.
   (Sort dropdown is handled by theme.js via [data-sort-select].)
   ============================================================ */
(function () {
  'use strict';

  var grid = document.querySelector('[data-collection-grid]');
  if (!grid) return;

  /* ---------- Filters drawer ---------- */
  var drawer = document.querySelector('[data-filters-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('open'); });
    });
    document.body.style.overflow = 'hidden';
    var panel = drawer.querySelector('.filters-drawer__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    window.setTimeout(function () { drawer.hidden = true; }, 350);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-filters-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Grid / list view toggle with localStorage memory ---------- */
  var viewBtns = document.querySelectorAll('[data-view-toggle]');
  var VIEW_KEY = 'lux_collection_view';

  function applyView(view) {
    grid.classList.toggle('is-list', view === 'list');
    viewBtns.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-view-toggle') === view ? 'true' : 'false');
    });
  }

  var savedView = null;
  try { savedView = localStorage.getItem(VIEW_KEY); } catch (err) { savedView = null; }
  if (savedView === 'list' || savedView === 'grid') applyView(savedView);

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var view = btn.getAttribute('data-view-toggle');
      applyView(view);
      try { localStorage.setItem(VIEW_KEY, view); } catch (err) { /* storage unavailable */ }
    });
  });

  /* ---------- Load more / infinite scroll (fetch next page, append cards) ---------- */
  var mode = grid.getAttribute('data-pagination-mode');
  if (mode !== 'load-more' && mode !== 'infinite') return;

  var nextUrl = grid.getAttribute('data-next-url');
  var loadBtn = document.querySelector('[data-load-more]');
  var sentinel = document.querySelector('[data-infinite-sentinel]');
  var statusEl = document.querySelector('[data-load-status]');
  var loading = false;

  function totalCount() {
    var t = parseInt(grid.getAttribute('data-total'), 10);
    return isNaN(t) ? 0 : t;
  }

  function shownCount() {
    return grid.querySelectorAll('.product-card').length;
  }

  function fetchNext() {
    if (loading || !nextUrl) return;
    loading = true;
    if (loadBtn) loadBtn.setAttribute('disabled', '');

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-collection-grid] .product-card');
        cards.forEach(function (card) {
          card.classList.add('in'); /* theme.js reveal only runs on initial load */
          grid.appendChild(card);
        });
        var nextGrid = doc.querySelector('[data-collection-grid]');
        nextUrl = nextGrid ? nextGrid.getAttribute('data-next-url') : null;

        var total = totalCount();
        if (statusEl && total) {
          statusEl.textContent = 'Showing ' + shownCount() + ' of ' + total + ' products';
        }
        if (!nextUrl) {
          if (loadBtn) loadBtn.hidden = true;
          if (sentinel) sentinel.hidden = true;
          if (statusEl && total) {
            statusEl.textContent = 'You have seen all ' + total + ' products';
          }
        }
      })
      .catch(function () {
        /* Graceful fallback: navigate to the next page */
        if (nextUrl) window.location.href = nextUrl;
      })
      .then(function () {
        loading = false;
        if (loadBtn) loadBtn.removeAttribute('disabled');
      });
  }

  if (mode === 'load-more' && loadBtn) {
    loadBtn.addEventListener('click', fetchNext);
  }

  if (mode === 'infinite') {
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) fetchNext();
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    } else if (loadBtn) {
      /* No IntersectionObserver: fall back to a button */
      loadBtn.hidden = false;
      loadBtn.addEventListener('click', fetchNext);
    }
  }
})();
